import {
  COMMON_QUERY_CONFIG,
  COMMON_QUERY_RULES_CONFIG,
  COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
  COMMON_VIDEO_QUERY_RULES_CONFIG,
  ruleNewsPlus
} from './shared/configs';

enum SECTION_ENUM {
  STYLE = 'Style',
  MAGAZINE = 'Magazine',
  FASHION = 'Fashion',
  DESIGN = 'Design',
  BEAUTY = 'Beauty',
  DEFAULT = 'Default',
  RELATED_OPINION = 'Related Opinion',
  VIDEO = 'Video'
}

const MAIN = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? []), ruleNewsPlus],
    or: [
      { terms: { key: 'DJEThing', value: ['style'] } },
      { terms: { key: 'Keyword', value: ['wsjstyle'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['style/fashion'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['style/design'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['style/beauty'] } }
    ]
  }
};

const MAGAZINE = {
  ...COMMON_QUERY_CONFIG,
  query: {
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? [])],
    and: [...(COMMON_QUERY_RULES_CONFIG.and ?? []), { terms: { key: 'Keyword', value: ['wsjstyle'] } }],
    or: [
      ...(COMMON_QUERY_RULES_CONFIG.or ?? []),
      { terms: { key: 'Keyword', value: ['wsjstyle-printmag'] } },
      { terms: { key: 'Keyword', value: ['tappable'] } }
    ]
  }
};

const FASHION = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['style/fashion'] } }]
  }
};

const DESIGN = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['style/design'] } }]
  }
};

const BEAUTY = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['style/beauty'] } }]
  }
};

const RELATED_OPINION = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
    and: [
      ...(COMMON_RELATED_OPINION_QUERY_RULES_CONFIG.and ?? []),
      {
        codes_with_significance: {
          key: 'djething',
          significance: ['significant'],
          value: ['style', 'wsjstyle', 'style/fashion', 'style/design', 'style/beauty']
        }
      }
    ],
    or: [],
    not: []
  }
};

const VIDEO = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_VIDEO_QUERY_RULES_CONFIG,
    or: [{ term: { key: 'DJEThing', value: 'style' } }, { prefix: { key: 'DJEThing', value: 'style/' } }],
    not: []
  }
};

export { MAIN, SECTION_ENUM, MAGAZINE, FASHION, DESIGN, BEAUTY, RELATED_OPINION, VIDEO };
